<template>
  <div class="FoodCourt">

    <div class='food_or_seller'>
      <div>&nbsp;</div>
      <div :class='{ "active": active === options[0].key }' @click='changeActive(options[0].key)'>{{options[0].label}}</div>
      <div>&nbsp;</div>
      <div :class='{ "active": active === options[1].key }'  @click='changeActive(options[1].key)'>{{options[1].label}}</div>
      <div>&nbsp;</div>
    </div>

    <FoodList v-if='active === 0'></FoodList>
    <SellerList v-if='active === 1'></SellerList>



    <div class='cart_wrap'>
      <Cart></Cart>
    </div>

  </div>
</template>
<script type="text/javascript" src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js" ></script>
<script>
import { mapGetters } from 'vuex';
import { Indicator } from 'mint-ui';
import FoodList from './eleme/FoodList';
import SellerList from './eleme/SellerList';
import Cart from './eleme/child/Cart';

export default {
  data() {
    return {
      active: 0,
      options: [
        { key: 0, label: '商品' },
        { key: 1, label: '店铺' },
      ],
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    };
  },
  methods: {
    changeActive(key) {
      this.active = key;
    },
    shere() {
      var imgUrl = 'http://ta-static.tianan.net/FopI_RXBBwQu1rwi0J8EeL-s0qyq'; 
      var lineLink = location.href.split('#')[0]; 
      var descContent = '感谢使用订餐服务，请于当天10：30前，选择时间及菜品，下单即可。我们将集中配送给您！';
      var shareTitle = '天安食堂叫餐服务';
      var appid = '';
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
          url: location.href.split('#')[0]
        }, {
          headers: { token: this.token }
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.scanConfig.appId = res.resData.appId;
            this.scanConfig.timestamp = res.resData.timestamp;
            this.scanConfig.nonceStr = res.resData.nonceStr;
            this.scanConfig.signature = res.resData.signature;
            wx.config({
                debug: false,
                appId: this.scanConfig.appId,
                timestamp: this.scanConfig.timestamp,
                nonceStr: this.scanConfig.nonceStr,
                signature: this.scanConfig.signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            });
            wx.ready(function() {
                          
                          wx.onMenuShareTimeline({
                              title: shareTitle, // 分享标题
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                          wx.onMenuShareAppMessage({
                              title: shareTitle, // 分享标题
                              desc: descContent, // 分享描述
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              type: '', // 分享类型,music、video或link，不填默认为link
                              dataUrl:'' , // 如果type是music或video，则要提供数据链接，默认为空
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                                  
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                  });
          } else {
            Toast.fail({ duration: 1500, message: res.resDesc });
          }
      });
    },
  },
  mounted() {
    this.shere();
  },
  components: { FoodList, SellerList, Cart },
  computed: {
    ...mapGetters(['token']),
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';
.FoodCourt{
  background: rgb(245, 245, 245);
  .food_or_seller{
    display: flex;
    height: 1.146667rem;
    line-height: 1.146667rem;
    border-bottom: .013333rem solid rgb(222, 222, 222);
    div{
      flex: 1 1 auto;
      text-align: center;
      &.active{
        border-bottom: .053333rem solid $color-main;
      }
    }
  }
  .cart_wrap{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 1.2rem;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/parkCompleteSet/components/FoodCourt.vue